import React, { useState } from 'react'
import {
  Stack, TextField, FormControl, InputLabel, Select,
  MenuItem, Typography, List, ListItemButton, ListItemText,
  Chip, Box
} from '@mui/material'
import { HttpClient } from '../../../api/httpClient'
import { API_URL } from '../../../api/RestAPI'
import apiHeaders from '../../../api/apiHeaders'
import SectionSpacingFields from './shared/SectionSpacingFields'
import useTranslation from '../../../hooks/useTranslation'

export default function FeaturedProductSettings({ settings, onChange }) {
  const { t } = useTranslation()
  const [searchResults, setSearchResults] = useState([])
  const [searchQuery, setSearchQuery] = useState('')

  const handleSearch = async (query) => {
    setSearchQuery(query)
    if (query.length < 2) {
      setSearchResults([])
      return
    }
    try {
      const res = await HttpClient.get(
        `${API_URL}/products?q=${encodeURIComponent(query)}&per_page=10`,
        apiHeaders()
      )
      setSearchResults(res.data?.data || [])
    } catch (err) {
      setSearchResults([])
    }
  }

  const handleSelect = (product) => {
    onChange({ ...settings, productId: product.id, productName: product.name })
    setSearchResults([])
    setSearchQuery('')
  }

  const handleClear = () => {
    onChange({ ...settings, productId: null, productName: '' })
  }

  return (
    <Stack spacing={2}>
      <SectionSpacingFields
        settings={settings}
        onChange={onChange}
      />

      {settings.productId ? (
        <Box>
          <Typography variant="caption" color="text.secondary" sx={{ mb: 0.5, display: 'block' }}>
            {t('labels.themes.selectedProduct')}
          </Typography>
          <Chip
            label={settings.productName || `Product #${settings.productId}`}
            onDelete={handleClear}
            color="primary"
            variant="outlined"
          />
        </Box>
      ) : (
        <>
          <TextField
            label={t('labels.themes.searchProduct')}
            size="small"
            fullWidth
            value={searchQuery}
            onChange={e => handleSearch(e.target.value)}
            placeholder={t('labels.themes.typeToSearch')}
          />
          {searchResults.length > 0 && (
            <List dense sx={{ bgcolor: 'background.paper', border: 1, borderColor: 'divider', borderRadius: 1, maxHeight: 200, overflow: 'auto' }}>
              {searchResults.map(p => (
                <ListItemButton key={p.id} onClick={() => handleSelect(p)}>
                  <ListItemText primary={p.name} />
                </ListItemButton>
              ))}
            </List>
          )}
        </>
      )}

      <FormControl size="small" fullWidth>
        <InputLabel>{t('labels.themes.layout')}</InputLabel>
        <Select
          value={settings.layout || 'side-by-side'}
          label={t('labels.themes.layout')}
          onChange={e => onChange({ ...settings, layout: e.target.value })}
        >
          <MenuItem value="side-by-side">{t('labels.themes.sideBySide')}</MenuItem>
          <MenuItem value="stacked">{t('labels.themes.stacked')}</MenuItem>
        </Select>
      </FormControl>
    </Stack>
  )
}